import { atom } from "jotai"
import { formData } from "./formData.store"
import { sortedOrderAtom } from "../fmpProjectTable/fmpSortedOrder.store"

// Snapshot of the project info fields and row order taken when the
// edit-fmp page data first loads (and again after a successful save),
// used to detect unsaved changes on the edit-fmp page.
export interface EditFmpFieldsSnapshot {
  projectName: string
  companyName: string
  projectAddress: string
  companyAddress: string
  revision: string
}

export const editFmpFieldsSnapshotAtom = atom<EditFmpFieldsSnapshot | null>(null)
export const editFmpRowOrderSnapshotAtom = atom<string[] | null>(null)

export const editFmpFieldsDirtyAtom = atom(get => {
  const fieldsSnapshot = get(editFmpFieldsSnapshotAtom)
  if (!fieldsSnapshot) {
    return false
  }
  const form = get(formData)
  return (
    (form.projectName ?? "") !== fieldsSnapshot.projectName ||
    (form.companyName ?? "") !== fieldsSnapshot.companyName ||
    (form.projectAddress ?? "") !== fieldsSnapshot.projectAddress ||
    (form.companyAddress ?? "") !== fieldsSnapshot.companyAddress ||
    (form.revision ?? "") !== fieldsSnapshot.revision
  )
})

export const editFmpRowOrderDirtyAtom = atom(get => {
  const rowOrderSnapshot = get(editFmpRowOrderSnapshotAtom)
  if (!rowOrderSnapshot) {
    return false
  }
  const currentRowOrder = get(sortedOrderAtom).map(item => (item?.id !== undefined && item?.id !== null ? String(item.id) : ""))
  return JSON.stringify(currentRowOrder) !== JSON.stringify(rowOrderSnapshot)
})

export const editFmpIsDirtyAtom = atom(get => get(editFmpFieldsDirtyAtom) || get(editFmpRowOrderDirtyAtom))

// Lets the (sibling) project-info row trigger the save logic that lives
// in EditFireManagementPlanTable.support.tsx, and read its loading state.
export const editFmpSaveTriggerAtom = atom<(() => void) | null>(null)
export const editFmpSaveLoadingAtom = atom<boolean>(false)
